import { render, staticRenderFns } from "./IndexExecutionWarning.vue?vue&type=template&id=bc8b3b4c&"
import script from "./IndexExecutionWarning.vue?vue&type=script&lang=js&"
export * from "./IndexExecutionWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports